<div
  class="flex min-h-screen flex-col items-center justify-center gap-10 bg-gray-100 py-10"
  *transloco="let t; read: 'auth.mailSentRecoverPassword'"
>
  <img src="assets/images/logo/taxtimer-logo.svg" alt="TaxTimer Logo" />

  <h2 class="text-primary">{{ t('title') }}</h2>
  <div class="relative z-10 flex min-h-[422px] w-[640px] flex-col items-center justify-center rounded-[5px] bg-white p-8">
    <h3 class="pb-10 text-center">{{ t('checkMailBoxTitle') }}</h3>
    <p class="text-large-bold text-center">{{ t('checkMailBoxContent', { email: email }) }}</p>
  </div>
  <app-legal-links-container></app-legal-links-container>
</div>
